import { createContext, useContext } from 'react'

export type AllocationPhase = 'questionnaire' | null

export interface AllocationContextType {
  phase: AllocationPhase
  setPhase: (phase: AllocationPhase) => void
  reset: () => void
}

export const AllocationContext = createContext<AllocationContextType | undefined>(undefined)

export const useAllocationContext = () => {
  const context = useContext(AllocationContext)
  if (!context) {
    throw new Error('useAllocationContext must be used within an AllocationProvider')
  }
  return context
}
